<template>
  <div class="context-viewer">
    <pre class="json-content">{{ prettyJson }}</pre>
  </div>
</template>

<script>
export default {
  name: 'ContextViewer',
  props: {
    context: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    prettyJson() {
      try {
        return JSON.stringify(this.context, null, 2);
      } catch (e) {
        return JSON.stringify({});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.context-viewer {
  width: 100%;
}

.json-content {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 300px;
  overflow-y: auto;
}
</style>